import { View } from "binder"
import { AddNewInterfacePersonViewModel } from "./addNewInterfacePerson-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { InterfacePersonSearchViewModel } from "../interfacePersonSearch/interfacePersonSearch-viewModel";

export class AddNewInterfacePersonView extends View<AddNewInterfacePersonViewModel>{
    GetViewUniqueId(): string {
        return "V-F12D3956-5523-4854-B40C-68B54A44531D"
    }
    loadHtml(): string {
        let element = require('./addNewInterfacePerson.html').default;
        let style = require('./addNewInterfacePerson.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set receiverId(v: string) { this._receiverId = v; } public get receiverId(): string { return this._receiverId;} private _receiverId: string;
    public set receiverName(v: string) { this._receiverName = v; } public get receiverName(): string { return this._receiverName; } private _receiverName: string;
    public set receiverPhone(v: string) { this._receiverPhone = v; } public get receiverPhone(): string { return this._receiverPhone;} private _receiverPhone: string;
    public set receiverComment(v: string) { this._receiverComment = v; } public get receiverComment(): string { return this._receiverComment;} private _receiverComment: string;
    public set interfacePersonsSelector(v: InterfacePersonSearchViewModel) { this._interfacePersonsSelector = v; } public get interfacePersonsSelector(): InterfacePersonSearchViewModel { return this._interfacePersonsSelector;} private _interfacePersonsSelector: InterfacePersonSearchViewModel;
    public set customerId(v: string) { this._customerId = v; } public get customerId(): string { return this._customerId;} private _customerId: string;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName; } private _customerName: string;
    
    closePopup() {
        this.dataContext.closePopup();   
    }
    
    save() {
        this.dataContext.save();   
    }
    
    employee(){
        this.receiverComment = "کارمند";
    }
    peik(){
        this.receiverComment = "پیک";
    }
    customer(){
        this.receiverComment = "مشتری";
    }
}
